/* global $:true module:true Flickity:true Foundation:true */
import debug from "debug";

const ZERO = 0;
const MODULE_NAME = 'core/modules/sliders/blocks';
const log = debug(MODULE_NAME);



function setSlideHeights() {
	log('setSlideHeights');

	$('.block-slider')
		.each(function ReduceSliderHeightFn () {
			const slider = $(this);
			let height = 0;

			$(slider).find('.slide-cell')
				.css('height', 'auto');

			$(slider).find('.slide-cell')
				.each(function FindSlideHeight () {
					const cell = $(this);
					const cellHeight = cell.height();
					if (cellHeight > height) {
						height = cellHeight;
					}
				});

			$(slider).find('.slide-cell')
				.css('height', height);

		});
}

function setupSliders() {
	log('setupSliders');

	$('.block-slider')
		.each(function SetupSlider () {
			const slider = $(this);
			const sliderElement = $(slider).get(ZERO);
			const wrapAround = $(slider).attr('data-wrap-around') === 'true';
			const autoPlay = $(slider).attr('data-auto-play') === 'true';

			const FlickityOptions = {
					autoPlay: autoPlay,
					wrapAround: wrapAround,
					adaptiveHeight: false,
					contain: true,
					cellAlign: 'left',
					groupCells: '100%'
			};

			const SliderInstance = new Flickity(sliderElement, FlickityOptions);
		});

	$(window).resize(() => {
		setSlideHeights();
	});
}

export default function () {
	setSlideHeights();
	setupSliders();
}





// WEBPACK FOOTER //
// ./client/src/core/modules/sliders/blocks.js